var _excluded = ["color", "textStyle", "as", "children", "shouldSupportEllipsis"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef, useRef } from 'react';
import { mergeRefs, useHasOverflowX } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { Tooltip } from '../Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export var Text = /*#__PURE__*/forwardRef((_ref, propRef) => {
  var {
    color = 'neutral.black',
    textStyle = 'body2',
    as = 'span',
    children,
    shouldSupportEllipsis = false
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var textRef = useRef(null);
  var ref = mergeRefs([textRef, propRef]);
  var styles = useStyleConfig('Text', {
    color,
    textStyle,
    shouldSupportEllipsis
  });
  var hasOverflow = useHasOverflowX({
    ref: textRef
  });
  var showTooltip = shouldSupportEllipsis && hasOverflow && typeof children === 'string';
  return /*#__PURE__*/_jsx(Tooltip, {
    label: children,
    isEnabled: showTooltip,
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      "data-component": "Text",
      as: as
    }, props), {}, {
      ref: ref,
      __css: styles,
      tabIndex: showTooltip ? 0 : -1,
      children: children
    }))
  });
});
Text.displayName = 'Text';
//# sourceMappingURL=Text.js.map